<template>

  <div class="login-container">
    <div class="container-login100">
      <div class="wrap-login100">
        <div class="login100-pic" data-tilt>
          <img :src="require('@/assets/2FA.png')" alt="IMG" />
        </div>


        <el-form :model="form" status-icon :rules="formRules" ref="authForm">
            <span class="login90-form-title">Two-factor authentication</span>
            <span class="login80-form-title">Open your authentication app and enter the code for ABBS.</span>
            <el-form-item prop="auth_token" label="6-digit code">
              <el-input type="number" v-model="form.auth_token" placeholder="Enter 6-digit code" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item>
              <div class="container-login100-form-btn">
                <el-button :loading="submiting" class="login100-form-btn" type="primary" @click="verifyCode()">Verify Code</el-button>
              </div>
            <div class="text-center p-t-12">
                <el-button type="text" @click="$router.push('/login')"> Go back to the sign in page</el-button>
			</div>
          </el-form-item>
        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
import {verify2Factor} from '@/api/user'
export default {
    data(){
        return {
            submiting: false,
            form:{
                auth_token: "",
                uid: this.$route.params.uid
            },
            formRules:{
                auth_token: [{
                    required: true,
                    message: "Verification code required",
                    trigger: "blur",
                }]
            }
        }
    },
    methods:{
        verifyCode(){
            this.$refs.authForm.validate((valid)=>{
                if(valid){
                    this.submiting = true;
                    verify2Factor(this.form).then(({result, data})=>{
                        this.submiting = false;
                        if(result){
                            this.$store.dispatch('user/setsession', data)
                            .then(() => {
                                this.$router.push('/')
                            })
                        }else{

                        }

                    })
                }
            })
        }
    }
}
</script>

<style lang="scss">
@import "~@/styles/login.scss";

</style>